import { useDispatch, useSelector } from "react-redux";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { Col, message, Row } from "antd";
import { AntdButton, InputField } from "../../../blueplanitUtils/InputField";
import { useState } from "react";
import { editClientsAsync, updateClientsAsync } from "../../../Slices/clientSlice";

const ClientMails = () => {
    const dispatch = useDispatch()
    const clients = useSelector((state) => state.clients.clients);
    const activeClitns = clients?.filter(client => client.status === "Active");
    const [isEditingBulk, setIsEditingBulk] = useState(false);
    const [editableRows, setEditableRows] = useState([]);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

    const columns = [
        {
            title: "Client Name",
            dataIndex: "clientName",
            Key: "clientName",
            render: (text, record) =>
                isEditingBulk ? (
                    <div style={{ width: "150px" }}>
                        <InputField
                            value={record.clientName}
                            disabled={true}
                            style={{
                                border: "none",
                                outline: "none",
                                width: "100%",
                            }}
                        />
                    </div>
                ) : (
                    text
                ),
        },
        {
            title: "Client Email",
            dataIndex: "emailId",
            key: "emailId",
            render: (text, record) =>
                isEditingBulk ? (
                    <InputField
                        value={editableRows.find(r => r.id === record.id)?.emailId || ""}
                        onChange={(e) => handleInlineEdit(record.id, e.target.value)}
                        style={{ border: "none", outline: "none", width: "100%" }}
                    />
                ) : (
                    text
                ),
        }

    ]

    const toggleBulkEdit = () => {
        if (!isEditingBulk) {
            setEditableRows(JSON.parse(JSON.stringify(activeClitns))); // deep copy
            setIsEditingBulk(true);
            return;
        }
        handleSubmitEdit();
    };

    const handleInlineEdit = (id, value) => {
        setEditableRows(prev =>
            prev.map(item =>
                item.id === id ? { ...item, emailId: value, isUpdated: true } : item
            )
        );
    };
    const cleanObject = (obj) => {
        const cleaned = { ...obj };
        delete cleaned.__typename;
        delete cleaned.isUpdated;
        delete cleaned.EditClient;
        return cleaned;
    };

    const handleSubmitEdit = async () => {
        const updatedRows = editableRows.filter(r => r.isUpdated);

        if (updatedRows.length === 0) {
            message.info("No changes detected.");
            return;
        }

        try {

            for (const updated of updatedRows) {

                const cleanedClient = cleanObject(updated);

                const resultAction = await dispatch(updateClientsAsync(cleanedClient));

                if (updateClientsAsync.fulfilled.match(resultAction)) {

                    const EditClient = {
                        id: `${loginUser.firstname} ${loginUser.lastname}`,
                        clientId: cleanedClient.id,
                        userName: cleanedClient.clientName,
                        EditStatus: "Updated",
                        changeTime: new Date().toISOString(),
                        action: "Email Update"
                    };

                    const cleanedEdit = cleanObject(EditClient);
                    await dispatch(editClientsAsync(cleanedEdit))
                  
                } else {
                    throw new Error("Failed to update client");
                }
            }

            message.success("Client emails updated successfully!");
            setIsEditingBulk(false);

        } catch (err) {
            console.error("Error updating clients:", err);
            message.error("Something went wrong while updating emails");
        } 
    };

    const handleClear = () => {
        setIsEditingBulk(false);
        message.info("Changes have been cleared");
    };

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                            <Row justify="end" style={{ marginTop: "20px", marginBottom: "10px" }}>
                                <Col>
                                    <AntdButton
                                        onClick={toggleBulkEdit}
                                        type="primary"
                                        style={{ marginRight: 8 }}
                                        label={isEditingBulk ? "Submit" : "Edit "}
                                    />
                                </Col>
                                {isEditingBulk && (
                                    <Col>
                                        <AntdButton
                                            style={{ marginRight: 8 }}
                                            onClick={handleClear}
                                            label="Clear"
                                        />
                                    </Col>
                                )}
                            </Row>
                            <CustomGridTable
                                columns={columns}
                                Id="client-mails-table"
                                dataSource={isEditingBulk ? editableRows : activeClitns}
                                pagination={true}
                                scroll={{ x: "max-content" }}
                                size="small"
                                bordered={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
};

export default ClientMails;